// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__0ZUPR","mb":"styles_mb__tJ9pA"};